import { Button } from 'components/Button/Button';
import { Stack } from 'components/Stack/Stack';
import type { CmsApiTag } from 'modules/cms/api/types/CmsApiTag';
import { spacing } from 'theme/theme';

type Props = {
  homePageUrl: string | undefined;
  tags: CmsApiTag[];
};

export function CmsTagList({ homePageUrl, tags }: Props) {
  return (
    <Stack direction="row" data-qa-id="tags" spacing={spacing[6]}>
      {tags.map((tag) => (
        <Button
          size="small"
          variant="secondary-green"
          key={tag.slug}
          type="link"
          data-qa-id="tag-link"
          href={homePageUrl ? `/${homePageUrl}?tags.slug=${tag.slug}&pq=` : ''}
        >
          {tag.tag.toUpperCase()}
        </Button>
      ))}
    </Stack>
  );
}
